import type { ListThreadMessagesParams } from '../../fetchers/chat/chat-fetchers';

export const chatKeys = {
    all: ['chat'] as const,
    attachmentOptions: () => [...chatKeys.all, 'attachment-options'] as const,
    attachments: (attachmentIds: readonly string[]) =>
        [...chatKeys.all, 'attachments', [...attachmentIds].sort()] as const,
    messages: (threadId: string, params?: ListThreadMessagesParams) =>
        [...chatKeys.thread(threadId), 'messages', params ?? {}] as const,
    thread: (threadId: string) => [...chatKeys.threads(), threadId] as const,
    threads: () => [...chatKeys.all, 'threads'] as const,
    userDisplayName: (userId: string) => [...chatKeys.all, 'user-display-name', userId] as const,
} as const;
